import React from 'react';

interface FileViewRendererProps {
  viewMode: 'grid' | 'list';
  GridComponent: React.ComponentType<any>;
  ListComponent: React.ComponentType<any>;
  commonViewProps: any;
}

export const FileViewRenderer: React.FC<FileViewRendererProps> = ({
  viewMode,
  GridComponent,
  ListComponent,
  commonViewProps,
}) => {
  return (
    <div className="min-h-0 flex-1 h-full overflow-hidden">
      {viewMode === 'grid' ? (
        <GridComponent {...commonViewProps} />
      ) : (
        <ListComponent {...commonViewProps} />
      )}
    </div>
  );
};
